/* Docteur B — navigation-2026-10-07 : pour un visiteur, chaque lien de connexion ramène au panier s'il contient des articles,
   sinon à la page en cours (accueil, création de compte et espace → Mon espace). Les liens qui portent déjà l'adresse du
   pharmacien (login_hint) ou un retour imposé (data-login-garde) ne sont pas touchés. Chargé pour les visiteurs seulement. */
(function () {
  'use strict';
  var LOGIN = /\/customer_authentication\/login|\/account\/login|shopify\.com\/\d+\/account/;
  function cible(panier) {
    if (panier) return '/cart';
    var p = location.pathname;
    if (p === '/' || /^\/(pages\/(creer-mon-compte|mon-espace)|account)/.test(p)) return '/pages/mon-espace';
    return p + location.search.replace(/[?&]preview_theme_id=\d+/, '').replace(/^&/, '?');
  }
  function poser(panier) {
    var r = '/customer_authentication/login?return_to=' + encodeURIComponent(cible(panier));
    document.querySelectorAll('a[href]').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (!LOGIN.test(h) || /login_hint=/.test(h) || a.hasAttribute('data-login-mail') || a.hasAttribute('data-login-garde')) return;
      if (h !== r) a.setAttribute('href', r);
    });
  }
  var t = null;
  function lire() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); })
        .then(function (c) { poser((c.item_count || 0) > 0); }).catch(function () { poser(false); });
    }, 120);
  }
  window.drbLiensConnexion = lire;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lire); else lire();
  window.addEventListener('load', function () { setTimeout(lire, 800); });   /* barre basse mobile construite après coup */
  try { if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, lire); } catch (e) {}
  document.addEventListener('cart:updated', lire);
})();
